import { usePageModels } from '@/context/PageModels';
import { getOr, keys, pipe } from 'lodash/fp';
import { useMemo } from 'react';
import { ComponentsFeatureConfiguration } from './usePageComponentsFeature.interfaces';
import { usePageComponentsFeatureStyles } from './usePageComponentsFeature.styles';

const resolveComponentFeatureConfig = (raw: any): ComponentsFeatureConfiguration => ({
  componentCornerStyle: raw?.components_corner_style || null,
  roundedSize: raw?.rounded_style_size || '24px',
});

export const usePageComponentsFeature = () => {
  const { config, globalRoundedStyleBlacklist } = usePageModels();

  const { componentCornerStyle, roundedSize }: ComponentsFeatureConfiguration = useMemo(
    () => pipe(getOr({}, 'feature'), resolveComponentFeatureConfig)(config as any),
    [config],
  );

  const excludedIds = useMemo(
    () => keys(globalRoundedStyleBlacklist),
    [globalRoundedStyleBlacklist],
  );

  usePageComponentsFeatureStyles({ excludedIds, radius: roundedSize });

  const globalStyleClasses = useMemo(() => {
    const classes: string[] = [];
    if (componentCornerStyle) classes.push(`global-component--${componentCornerStyle}`);
    return classes;
  }, [componentCornerStyle]);

  return {
    globalStyleClasses,
  };
};
